import React from 'react';
import Edit from '../../../containers/rest/Edit';
import Form from '../components/Form';

const OrderHistoriesEdit = props => (
  <Edit {...props} resource="orderHistories">
    <Form />
  </Edit>
);

OrderHistoriesEdit.propTypes = {};

export default OrderHistoriesEdit;
